// extracted by mini-css-extract-plugin
module.exports = {"branch-table":"AppLuckyOCB_branch-table__g6OQl","border-right":"AppLuckyOCB_border-right__EAr1R","selected-branch":"AppLuckyOCB_selected-branch__5HHxC"};